module.exports = __webpack_public_path__ + "static/img/img32.248b0a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cartojourney/img32.png
// module id = LOn8
// module chunks = 1